export default defineNuxtRouteMiddleware((to) => {
  const { captureFromQuery, utm } = useOrderUtm()

  captureFromQuery(to.query)

  if (!hasUtmValues(utm.value)) return

  const needsUtmInUrl = Object.entries(utm.value).some(
    ([key, value]) => to.query[key] !== value,
  )

  if (!needsUtmInUrl) return

  return navigateTo(
    { path: to.path, query: { ...to.query, ...utm.value } },
    { replace: true },
  )
})
